import React, { createContext } from 'react';
import usePreviousQueryState from './usePreviousQueryState';
const OptimistContext = createContext(undefined);
/**
 * Stores all globally needed information for Optimist. This should be placed at a very high, probably global level in apps.
 */
export const OptimistProvider = ({ children }) => {
    const { setPreviousQueryState, getPreviousQueryState } = usePreviousQueryState();
    return (React.createElement(OptimistContext.Provider, { value: { setPreviousQueryState, getPreviousQueryState } }, children));
};
export default OptimistContext;
//# sourceMappingURL=index.js.map